(() => {
  'use strict';
  const marker = '[data-fsb-top-hero]';
  const timerSelector = '.gta-widget.GSC-BAR-kWHCocIrolnI';
  const headerSelector = '.section-header';
  const property = '--fsb-top-stack';
  let active = false, raf = null;
  let observed = new Set();
  let previous;
  const resize = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
  const mutation = typeof MutationObserver === 'function' ? new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes,...r.removedNodes].some(n => n.nodeType === 1 && (n.matches?.(`${timerSelector},${headerSelector},${marker}`) || n.querySelector?.(`${timerSelector},${headerSelector},${marker}`))))) mount();
  }) : null;
  function schedule(){ if(active && raf === null) raf=requestAnimationFrame(measure); }
  function measure(){
    raf=null;
    if(!active) return;
    const nodes=[...document.querySelectorAll(`${timerSelector},${headerSelector}`)];
    observed.forEach(n=>{if(!nodes.includes(n)){resize?.unobserve(n);observed.delete(n);}});
    let height=0;
    nodes.forEach(n=>{if(!observed.has(n)){resize?.observe(n);observed.add(n);} const s=getComputedStyle(n);if(s.display!=='none' && s.position!=='fixed' && s.position!=='absolute')height+=n.getBoundingClientRect().height;});
    const value=`${height}px`;
    if(document.documentElement.style.getPropertyValue(property)!==value)document.documentElement.style.setProperty(property,value);
  }
  function mount(){
    if(!document.querySelector(marker)){unmount();return;}
    if(!active){active=true;previous=document.documentElement.style.getPropertyValue(property);window.addEventListener('resize',schedule,{passive:true});window.addEventListener('pageshow',schedule);mutation?.observe(document.body,{childList:true,subtree:true});}
    schedule();
  }
  function unmount(){
    if(!active)return;active=false;if(raf!==null)cancelAnimationFrame(raf);raf=null;resize?.disconnect();mutation?.disconnect();observed.clear();window.removeEventListener('resize',schedule);window.removeEventListener('pageshow',schedule);
    if(previous)document.documentElement.style.setProperty(property,previous);else document.documentElement.style.removeProperty(property);
  }
  document.addEventListener('shopify:section:load',mount);
  document.addEventListener('shopify:section:unload',event=>{if(event.target.querySelector?.(marker)||event.target.matches?.(marker))unmount();});
  mount();
})();
